import { FC, useEffect } from 'react'
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import { isNonEmptyString } from '@utils/type-checkers'
import * as Sentry from "@sentry/react"
import './sign-up.css'

// COMPONENTS
import * as Icons from '@icons'
import { Column } from '@components/templates/column'

// ROUTES
import BillingRoute from './billing'
import KycRoute from './kyc'
import KYCExplainerRoute from './kyc-explainer'
import ReloadableCardRoute from './reloadable-card'
import AddInfoRoute from './add-info'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { createAuthenticatedLoader } from '@utils/loaders'


interface Props { }

const Layout: FC<Props> = () => {
    const { isLoaded, user } = useUser()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (isLoaded && user) {
            if (!location.pathname.includes('/sign-up/add-info') && (!isNonEmptyString(user.firstName) || !isNonEmptyString(user.lastName))) {
                Sentry.addBreadcrumb({ category: 'sign-up', message: 'missing name, redirecting to /sign-up/add-info', level: 'info' })
                navigate(`/sign-up/add-info${document.location.search}`, { replace: true })
            }
        }
    }, [isLoaded, user, navigate, location])

    return (
        <Column className="kyc-stack">
            <Column.Header.End>
                <Link className="account-redirect-container" to="/account">
                    <Icons.House tint="var(--splitcard-black)" />
                </Link>
            </Column.Header.End>
            <Outlet />
        </Column>
    )
}

const loader = createAuthenticatedLoader(() => null)

const SignUpRoute: RouteObject = {
    path: "sign-up",
    element: <Layout />,
    loader,
    children: [
        AddInfoRoute,
        BillingRoute,
        KycRoute,
        KYCExplainerRoute,
        ReloadableCardRoute
    ],
}

export default SignUpRoute
